import emailValidator from '../../../utils/Validate';

export const validate = (values: any): any => {
  const errors: any = {};
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'Please enter username!';
  } else if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.password = 'Please enter password';
  }
  return errors;
};
// Takes date object
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getDiffInSeconds = (timeObj1: any, timeObj2: any) => {
  const diff = (timeObj1.getTime() - timeObj2.getTime()) / 1000;
  return Math.abs(Math.round(diff));
};

export const validateHookForm = (values: any): any => {
  const errors: any = [];
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.push({name: 'email', type: '', message: 'Please enter username!'});
  } else if (emailValidator(values.email) === false) {
    errors.push({
      name: 'email',
      type: '',
      message: 'Please enter valid email!'
    });
  } else if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.push({
      name: 'password',
      type: '',
      message: 'Please enter password!'
    });
  }
  return errors;
};
// Latest one - Oct 2020
export const validateWithHookForm = (values: any): any => {
  let errors: any = {
    email: '',
    password: ''
  };
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'VALIDATORS.EMAIL_REQ';
  } else if (!emailValidator(String(values.email).toLowerCase())) {
    errors.email = 'VALIDATORS.INVALID_EMAIL';
  }
  if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.password = 'LOGIN.PASSWORD_REQ';
  }
  if (!errors.email && !errors.password) {
    errors = {};
  }
  return errors;
};
